import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es un manual físico o digital?',
  a: 'Es 100% digital en formato PDF. Lo recibís por email inmediatamente después de la compra. Podés leerlo desde el celular, la tablet o la computadora. Sin esperas, sin envíos, sin complicaciones.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El Tomo 1 arranca desde cero absoluto. Te explicamos qué herramientas comprar primero, cómo usarlas y cómo hacer tu primera pieza paso a paso. Si tenés experiencia, los tomos 2 al 5 te van a acelerar el negocio directamente.'
}, {
  q: '¿Cuándo lo recibo después de comprar?',
  a: 'En menos de 5 minutos. Apenas confirmás el pago, recibís un email con el enlace de descarga. Podés empezar a leer hoy mismo.'
}, {
  q: '¿Qué herramientas necesito para empezar?',
  a: 'Las básicas: amoladora, soldadora y metro. En el Tomo 1 te explicamos exactamente qué comprar primero y qué podés conseguir de segunda mano para arrancar sin invertir una fortuna.'
}, {
  q: '¿Cuánto tardo en ver resultados?',
  a: 'Depende de tu ritmo, pero los que siguen el sistema completo del Acelerador tienen su primera venta en los primeros 30 días. Los que aplican solo el Tomo 2 y el Tomo 4 ya reportan sus primeras consultas en Marketplace en la primera semana.'
}, {
  q: '¿Puedo hacerlo si no tengo taller?',
  a: 'Sí. Podés empezar en un garage, en el fondo de tu casa o en cualquier espacio con ventilación. El Bono 3 — Checklist Taller Seguro te muestra cómo organizar cualquier espacio para trabajar de forma segura y prolija desde el primer día.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si no te convence, escribinos y te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <h2 className="text-4xl font-black text-center text-brand-dark mb-12" data-id="element-82">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-84">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-86">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-amber flex-shrink-0" data-id="element-87" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-88" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-89">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}